import { usePageTitle } from 'slab'

import { QuoteSelfServeExplorer } from './QuoteSelfServeExplorer'

export function QuotePage () {
  usePageTitle('Get a quote')

  return <QuoteSelfServeExplorer />
}
